// client/src/pages/RegisterPage.js
import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { TextField, Button, Alert, Stack } from '@mui/material';
import AuthLayout from '../components/AuthLayout';
import { API_BASE_URL } from '../utils/media';
import { useStore } from '../context/StoreContext';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  const { store } = useStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/register`, { email, password });
      navigate(`/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Join us"
      title={`Create your ${store.name} account`}
      footer={(
        <>
          Already have an account?{' '}
          <Link to={`/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`} style={{ color: 'inherit', fontWeight: 700 }}>
            Sign in
          </Link>
        </>
      )}
    >
          <Stack component="form" onSubmit={handleSubmit} spacing={2.25}>
            {error && <Alert severity="error">{error}</Alert>}
            <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth autoComplete="email" />
            <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required fullWidth autoComplete="new-password" />
            <Button type="submit" variant="contained" size="large" disabled={loading} sx={{ py: 1.5, fontWeight: 700 }}>
              {loading ? 'Creating account…' : 'Create account'}
            </Button>
          </Stack>
    </AuthLayout>
  );
};

export default RegisterPage;
